import { contextualize } from '@polleverywhere/cutlass'
import AnalyticsTracker from '../analytics_tracker'
import { trackingAllowed, whenAllowedToTrack } from '../analytics_tracker/util'
import setupCannon from './setupCannon'

function contextualizedPrefix (role) {
  switch (role) {
    case 'embed':
    case 'participant':
      // To maintain compatibility with prior mobile/pollev.com events, don't prefix
      return ''
    default:
      return 'singularity'
  }
}

/**
 * Sent events to Cutlass
 */
export default (app) => {
  const trackingOnHold = !trackingAllowed(app)
  const cannon = setupCannon(app, trackingOnHold)

  if (!cannon) { return }

  const tracker = AnalyticsTracker(app)

  const defaultProperties = () =>
    _.pick(tracker.toJSON(), [
      'isNative',
      'platform',
      'role',
      'screen',
      'mode',
      'activePresenter',
      'iframed',
      'os'
    ])

  const trackEvent = (name, properties = {}) =>
    cannon.addEvent(`singularity:${name}`,
      { ...defaultProperties(), ...properties })

  tracker.on('change:userId', (_, userId) => {
    cannon.userId = userId
  })

  tracker.on('change:screen', () => trackEvent('$view'))
  tracker.on('action', trackEvent)
  tracker.on('event', trackEvent)

  if (trackingOnHold) {
    whenAllowedToTrack(app, tracker).then(() => cannon.allowTracking())
  }

  contextualize(app.el, contextualizedPrefix(app.options?.role), (event) => {
    Object.assign(event.detail, defaultProperties())
  })

  cannon.trackCustomDomEvents()
}
